module.exports = __webpack_public_path__ + "img/aetj.1efedece.jpg";